module.exports = __webpack_public_path__ + "static/PandPlogo-f14a705375f56c12028cbbdfb1a1e31a.png";